import { SelectedBookingOptions } from 'entities/booking';
import { doctorsStore } from 'features/doctors';
import { Fragment } from 'react/jsx-runtime';
import { useEffect, useState } from 'react';
import { DoctorsSchedule } from 'widgets/schedule';
import { useParams } from 'react-router-dom';

export const DoctorsSelection = () => {
  const [ showOptions, setShowOptions ] = useState<boolean>(true);
	useEffect(() => {
		doctorsStore.resetDoctors();
	}, []);

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      setShowOptions(false)
    } else {
      setShowOptions(true)
    }
  }, [id])

	return (
		<Fragment>
			<div className="mb-2">
      {showOptions && 
				<SelectedBookingOptions showClinics={true} />
      }
			</div>
			<DoctorsSchedule />
		</Fragment>
	);
};
